import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { Button, Card } from "react-bootstrap";
import { Loading } from "../../Components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { VendorForm } from "../../Components/Vendors/VendorForm";

const EditVendor = () => {
  const { get } = useAxios();
  const navigate = useNavigate();
  let { vendorId } = useParams();
  const [banks, setBanks] = useState({});
  const [vendor, setVendor] = useState({});
  const [fetching, setFetching] = useState(true);
  const [specialities, setSpecialities] = useState([]);
  const [vendorEditData, setVendorEditData] = useState([]);

  useEffect(() => {
    setFetching(true);
    const getDetailedVendor = async () => {
      try {
        const response = await get(`vendors/${vendorId}/edit`);
        setBanks(response.data.banks);
        setVendor(response.data.vendors);
        setVendorEditData(response.data);
      } catch (error) {
      } finally {
        setFetching(false);
      }
    };
    getDetailedVendor();
  }, []);

  return (
    <>
      {!!fetching && <Loading />}
      {!fetching && !!vendorEditData?.vendors?.id && (
        <Card className="container">
          <Card.Header className="d-flex justify-content-between mt-0 mb-5">
            <Card.Title>
              <div className="row">
                <div className="col-md-12">
                  <h1 className="page-title">Edit Vendor</h1>
                </div>
              </div>
            </Card.Title>

            <div className="row">
              <div className="col-md-12">
                <Button onClick={() => navigate(-1)}>Back</Button>
              </div>
            </div>
          </Card.Header>

          <Card.Body>
            <VendorForm
              editVendor={vendor}
              bankNames={banks}
              vendorSpecialities={specialities}
            />
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default EditVendor;
